import "./contacts-page.scss";

type ContactsPageProps = {};

const ContactsPage = (props: ContactsPageProps) => {
  return (
    <>
      <div className="contacts page">
        <div className="contacts__header page__header">
          <h1 className="contacts__header__title page__header__title">
            КОНТАКТИ
          </h1>
        </div>
        <div className="contacts__body">
          <div className="contacts__body__content">
            <div className="contacts__body__content__item">
              <p>Име:</p>
              <p>
                <strong>Евгения Асенова Арнаудова</strong>
              </p>
            </div>
            <div className="contacts__body__content__item">
              <p>Email:</p>
              <p>
                <strong>evgeniq_arnaudova@abv.bg</strong>
              </p>
            </div>
            <div className="contacts__body__content__item">
              <p>Служебен акаунт:</p>
              <p>
                <strong>evgeniia.as.petrova@edu.mon.bg</strong>
              </p>
            </div>
            <div className="contacts__body__content__item">
              <p>Телефон:</p>
              <p>
                <strong>0878543328 </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <p></p>
    </>
  );
};

export default ContactsPage;
